/* eslint-disable */
/* Code generated by generator.ts DO NOT EDIT. */
// Generated: 05-11-2026 12:02:02

export enum CohortstatusVanaf {
    NOG_BEZIG = "Nog bezig",
    TUSSENTIJDS_UITGESTROOMD = "Tussentijds uitgestroomd",
    VOLLEDIG_COHORT_GEVOLGD = "Volledig cohort gevolgd"
}
